import { useDispatch, useSelector } from "@redux";
import { getAddress } from "@redux/config/actions";
import { Col, Form } from "antd";
import { useEffect, useState } from "react"
import SelectCustom from "./SelectCustom";
import { DynamicObjectType } from "types/commons";
import { useRestContext } from "components/form/RestInputContext";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { NamePath } from "antd/es/form/interface";

interface VNCitySelectorTypes {
   nameCity?: NamePath;
   hasWard?: boolean;
   hasDistrict?: boolean;
   isRequired?: boolean;
}

export default function VNCitySelector({ nameCity, hasWard = true, hasDistrict = true, isRequired = true }: VNCitySelectorTypes) {
   const dispatch = useDispatch();
   const { t } = useTranslation();
   const { form } = useRestContext();
   const cities = useSelector((state) => state.config.address) as DynamicObjectType[];

   const [districts, setDistricts] = useState([]);
   const [wards, setWards] = useState([]);


   const selectCity = (e) => {
      const selectedCity = cities?.find((city) => city.id === e);
      setDistricts(selectedCity.districts);
      form.setFieldsValue({
         districtId: null,
         wardId: null,
      });
      return e;
  };
   
   const selectDistrict = (e) => {
      setWards(districts.find((district) => district.id === e)?.wards);
      form.setFieldsValue({
         wardId: null,
      });
      return e;
  };

   useEffect(() => {
      dispatch(getAddress());
   }, []);

   return (
      <>
         <Col md={12} sm={24} xs={24}>
            <SelectCustom
               source={nameCity || 'provinceId'}
               subSource="province"
               resourceData={cities}
               titleProp="name"
               valueProp="id"
               formOptions={{ getValueFromEvent: selectCity }}
               header={!nameCity && t('mores.locations.address.city.label')}
               placeholder={t('mores.locations.address.city.placeholder')}
               required={isRequired}
            />
         </Col>
         {hasDistrict && (
            <Col md={12} sm={24} xs={24}>
               <SelectCustom
                  source="districtId"
                  subSource="district"
                  resourceData={districts}
                  titleProp="name"
                  valueProp="id"
                  header={t('mores.locations.address.district.label')}
                  formOptions={{ getValueFromEvent: selectDistrict }}
                  placeholder={t('mores.locations.address.district.placeholder')}
                  required={isRequired}
               />
            </Col>
         )}
         {hasWard && (
            <Col md={12} sm={24} xs={24}>
               <SelectCustom
                  source="wardId"
                  subSource="ward"
                  resourceData={wards}
                  titleProp="name"
                  valueProp="id"
                  header={t('mores.locations.address.ward.label')}
                  placeholder={t('mores.locations.address.ward.placeholder')}
                  required={isRequired}
               />
            </Col>
         )}
         <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) => {
               const selectedCity = cities?.find(
                  (city) => city.id === get(curValues, 'provinceId'),
               );
               if (
                  !districts?.length &&
                  get(curValues, 'provinceId') &&
                  selectedCity?.districts
               ) {
                  setDistricts(selectedCity.districts);
               }
               if (
                  get(prevValues, 'provinceId') !== get(curValues, 'provinceId') &&
                  selectedCity?.districts
               ) {
                  setDistricts(selectedCity?.districts);
               }
               if (
                  !wards?.length &&
                  get(curValues, 'districtId') &&
                  selectedCity?.districts
               ) {
                  setWards(
                  selectedCity?.districts?.find(
                     (district) => district.id === get(curValues, 'districtId'),
                  )?.wards,
                  );
               }
               if (
                  get(prevValues, 'districtId') !== get(curValues, 'districtId') &&
                  selectedCity?.districts
               ) {
                  setWards(
                  selectedCity?.districts?.find(
                     (district) => district.id === get(curValues, 'districtId'),
                  )?.wards,
                  );
               }
               return true;
            }}
            >
            {() => null}
         </Form.Item>
      </>
   )
}
